import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccessibilityModule } from '@fgb/portal-component-library/accessibility';
import { NotificationModule } from '@fgb/portal-component-library/src/lib/club/notification';
import { NavbarDirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { CartItemModule } from '@fgb/portal-component-library/src/lib/loyalty/cart-item';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { LanguageSelectorModule } from '@fgb/portal-component-library/src/lib/shared/language-selector';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { SharedModule } from 'src/app/shared/shared.module';
import { ClubModule } from '../club/club.module';
import { GuardianModule } from '../guardian/guardian.module';
import { UserModule } from '../user/user.module';
import { AccountNavComponent } from './components/account-nav/account-nav.component';
import { ArenaCashNavComponent } from './components/arena-cash-nav/arena-cash-nav.component';
import { FloatingCartButtonComponent } from './components/floating-cart-button/floating-cart-button.component';
import { FooterComponent } from './components/footer/footer.component';
import { GameNavComponent } from './components/game-nav/game-nav.component';
import { HomeNavComponent } from './components/home-nav/home-nav.component';
import { MixedLoyaltyNavComponent } from './components/mixed-loyalty-nav/mixed-loyalty-nav.component';
import { MobileNavMenuComponent } from './components/mobile-nav-menu/mobile-nav-menu.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { NavigationIndicatorComponent } from './components/navigation-indicator/navigation-indicator.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PaymentNavComponent } from './components/payment-nav/payment-nav.component';
import { PortalGamesBannerComponent } from './components/portal-games-banner/portal-games-banner.component';
import { ScorecardNavComponent } from './components/scorecard-nav/scorecard-nav.component';
import { FantasyNavComponent } from './components/fantasy-nav/fantasy-nav.component';
@NgModule({
  declarations: [
    NavBarComponent,
    NavigationIndicatorComponent,
    FooterComponent,
    MixedLoyaltyNavComponent,
    AccountNavComponent,
    PortalGamesBannerComponent,
    MobileNavMenuComponent,
    FloatingCartButtonComponent,
    ArenaCashNavComponent,
    HomeNavComponent,
    ScorecardNavComponent,
    PageHeaderComponent,
    PaymentNavComponent,
    FantasyNavComponent
  ],
  imports: [
    RouterModule,
    NgbModule,
    NgbAccordionModule,
    CommonModule,
    FormsModule,
    InlineSVGModule,
    SharedModule,
    UserModule,
    ClubModule,
    GuardianModule,
    LanguageSelectorModule,
    LoyaltyIconModule,
    CartItemModule,
    AccessibilityModule,
    NotificationModule,
    NavbarDirectivesModule,
    FGBSharedModule,
    ReactiveFormsModule,
    GameNavComponent,
  ],
  exports: [
    NavBarComponent,
    NavigationIndicatorComponent,
    FooterComponent,
    MixedLoyaltyNavComponent,
    AccountNavComponent,
    GameNavComponent,
    MobileNavMenuComponent,
    FloatingCartButtonComponent,
    ArenaCashNavComponent,
    HomeNavComponent,
    ScorecardNavComponent,
    PortalGamesBannerComponent,
    PageHeaderComponent,
    PaymentNavComponent,
    FantasyNavComponent
  ],
})
export class LayoutModule { }
